import type { CSSProperties } from "react";
import { useDateFormatter } from "../../contexts/Translation";
import { WithChildren } from "@/types";
import styles from "./Quote.module.css";

type QuoteProps = WithChildren & {
  from?: string;
  date?: string;
  iconColor?: string;
  className?: string;
};

const Quote = ({ children, from, date, iconColor, className }: QuoteProps) => {
  const d = useDateFormatter();

  return (
    <div className={[styles.quote, className].filter(Boolean).join(" ")}>
      <div className={styles.mark} style={{ "--quote-icon-color": iconColor ?? "var(--color-border-primary)" } as CSSProperties}>
        "
      </div>
      <div className={styles.body}>{children}</div>
      {from ? (
        <div className={styles.meta}>
          ― {from} <span className={styles.date}>{date ? `(${d(date)})` : null}</span>
        </div>
      ) : null}
    </div>
  );
};

export default Quote;
